import { createContext, useContext } from 'react'

/**
 * The id of the dashboard a widget is shown in (authenticated view and
 * editor; the public share view has its own routes). Table loaders send it
 * as ?dashboard=<id>: when the customer's email domain list (migration
 * 000156) would hide a table from the viewer, the server still serves it if
 * this dashboard is visible to them, is owned by the table's owner and
 * shows that table (the dashboard grant, goapi domain_visibility.go).
 */
export const DashboardGrantContext = createContext<string | null>(null)

export const useDashboardGrantId = () => useContext(DashboardGrantContext)
